import { Button } from '@mui/material';
import { UserMinus } from 'lucide-react';
import { useIntl } from 'react-intl';
import { postRelease } from '~/backend/connector-next-api/patientWritesClient';
import { enqueueSnackbar } from '~/utils/notifications';
import { usePatientWrite } from '../hooks';

/**
 * Releases a patient assigned to the user, guarded by the patient's version.
 * A refusal is told in a snackbar rather than beside the button: the refusal
 * refreshes the lists, which can move the patient off the one showing it.
 */
export default function ReleaseButton({
    patient,
}: {
    patient: { id?: string | null; version?: string | null };
}) {
    const intl = useIntl();
    const { write, canWrite, isSaving } = usePatientWrite(
        patient,
        (_change: void, id, version) => postRelease(id, version),
        () =>
            enqueueSnackbar(
                intl.formatMessage({ id: 'patientList.tasks.saveFailed' }),
                { variant: 'error' }
            )
    );
    return (
        <Button
            size="small"
            variant="outlined"
            disabled={isSaving || !canWrite}
            startIcon={<UserMinus size={16} />}
            onClick={() => write()}
            sx={{ whiteSpace: 'nowrap', px: 1.5 }}
        >
            {intl.formatMessage({ id: 'patientList.tasks.release' })}
        </Button>
    );
}
